import { UseMutateAsyncFunction, useMutation, useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router"
import { appRoutes } from "../../../routes/appRoutes"
import { AUTH_TOKEN_KEY, SELECTED_WORKSPACE_KEY, USER_DETAILS_KEY } from "../../../constants"
import { useAxios } from "../../../contexts/AxiosContext"
import { StorageService } from "../../../services"
import { resolveWorkspaceSelection } from "../../../utils/workspaceSelection"
import { useAuthService, VerifyOtpResponse } from "../services/useAuthService"

type VerifyOtpProps = {
  otp: string,
  email: string,
}

type UseVerifyOtpType = UseMutateAsyncFunction<VerifyOtpResponse, unknown, VerifyOtpProps, unknown>

const useVerifyOtp = (): UseVerifyOtpType => {

  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const authService = useAuthService()
  const axios = useAxios()

  const { mutateAsync: verifyOtpMutation } = useMutation({
    mutationFn: async (params: VerifyOtpProps) => {
      return authService.verifyOtp(params.otp, params.email)
    },
    onSuccess: async (data: VerifyOtpResponse) => {
      await axios.setToken(data.access_token)
      await StorageService.setStorageItem(AUTH_TOKEN_KEY, data.access_token)
      const workspaceId = resolveWorkspaceSelection({
        workspaces: data.workspaces,
        activeWorkspaces: data.active_workspace,
      })
      if (workspaceId) {
        await StorageService.setStorageItem(SELECTED_WORKSPACE_KEY, workspaceId)
      }
      await queryClient.invalidateQueries({ queryKey: [USER_DETAILS_KEY] })
      navigate(appRoutes.workspace.pendingInvites(data.user.email))
    },
    onError: () => {
      // show error message to the user toast
    },
  })

  return verifyOtpMutation
}

export default useVerifyOtp
